module.exports = __webpack_public_path__ + "4e8fc33729ac0cfe577a527d7988adda.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/mer-tail-green.png
// module id = 1312
// module chunks = 0